import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import { addHappyFoxId } from '../utils/add-happy-fox-id';
import { getAttributeValue } from '../utils/get-attribute-value';
import template from './contact-us-tabs.component.html';
var ContactUsTabsComponent = (function () {
    function ContactUsTabsComponent(contactUsApi) {
        this.contactUsApi = contactUsApi;
        this.lazyTabs = [];
    }
    ContactUsTabsComponent.prototype.ngOnChanges = function () {
        var _this = this;
        if (!this.group) {
            return;
        }
        this.contactUsApi.get(this.spotId)
            .then(function (spot) {
            _this.spot = spot;
            addHappyFoxId(_this.spot, _this.group);
        });
    };
    ContactUsTabsComponent.prototype.getAvailableTabs = function () {
        var availableTabs = [];
        if (!this.spot) {
            return availableTabs;
        }
        for (var _i = 0, _a = this.spot.tabs; _i < _a.length; _i++) {
            var tab = _a[_i];
            var config = this.getTabSelectedConfiguration(tab);
            if (!config) {
                continue;
            }
            tab.title = config.title;
            config.selected = true;
            availableTabs.push(tab);
        }
        if (availableTabs.length > 0 && !availableTabs.some(function (x) { return x.selected; })) {
            var firstAvailableTab = availableTabs
                .filter(function (x) {
                return x.configurations.some(function (c) { return c.selected; });
            })[0];
            if (firstAvailableTab) {
                firstAvailableTab.selected = true;
                if (this.lazyTabs.length === 0) {
                    this.lazyTabs.push(firstAvailableTab);
                }
            }
        }
        return availableTabs;
    };
    Object.defineProperty(ContactUsTabsComponent.prototype, "selectedTab", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.spot) === null || _a === void 0 ? void 0 : _a.tabs) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return x.selected; })[0];
        },
        enumerable: false,
        configurable: true
    });
    ContactUsTabsComponent.prototype.select = function (tab) {
        this.spot.tabs.forEach(function (x) {
            x.selected = false;
        });
        tab.selected = true;
        if (this.lazyTabs.indexOf(tab) === -1) {
            this.lazyTabs.push(tab);
        }
    };
    ContactUsTabsComponent.prototype.getTabSelectedConfiguration = function (tab) {
        var _this = this;
        var contextTab = tab;
        if (!contextTab) {
            contextTab = this.selectedTab;
        }
        if (!contextTab) {
            return undefined;
        }
        var productType = getAttributeValue(this.group, 'meta_producttype');
        return contextTab.configurations
            .filter(function (x) {
            var _a;
            return (!x.segmentType || x.segmentType === ((_a = _this.group) === null || _a === void 0 ? void 0 : _a.segmentType)) &&
                (!x.productType || (x.hideForProductType ? x.productType !== productType : x.productType === productType));
        })[0];
    };
    ContactUsTabsComponent.$inject = ['contactUsApi'];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ContactUsTabsComponent.prototype, "group", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ContactUsTabsComponent.prototype, "spotId", void 0);
    ContactUsTabsComponent = __decorate([
        Component({
            selector: 'contactUsTabs',
            template: template,
        }),
        __param(0, Inject('contactUsApi')),
        __metadata("design:paramtypes", [Object])
    ], ContactUsTabsComponent);
    return ContactUsTabsComponent;
}());
export { ContactUsTabsComponent };
